
define('text!libs/strand/src/strand-textarea/example.html',[],function () { return '<strand-textarea rows="10" placeholder="type here please"></strand-textarea>\n<strand-textarea rows="10" placeholder="place &lt;code&gt; here" fitparent mono></strand-textarea>';});

